// react
import React from 'react';

// third-party
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

// application
import AsyncAction from '../shared/AsyncAction';
import Currency from '../shared/Currency';
import Indicator from './Indicator';
import { Cart20Svg, Cross10Svg } from '../../svg';
import { cartRemoveItem } from '../../store/cart';


function IndicatorCart(props) {
    const { cart, cartRemoveItem } = props;
    let dropdown;
    let totals;

    if (cart.extraLines.length > 0) {
        const extraLines = cart.extraLines.map((extraLine, index) => (
            <tr key={index}>
                <th>{extraLine.title}</th>
                <td><Currency value={extraLine.price} /></td>
            </tr>
        ));

        totals = (
            <React.Fragment>
                <tr>
                    <th>Промежуточный итог</th>
                    <td><Currency value={cart.subtotal} /></td>
                </tr>
                {extraLines}
            </React.Fragment>
        );
    }

    const items = cart.items.map((item) => {
        let options = null;
        if (item.options && item.options.length > 0) {
            options = (
                <ul className="dropcart__product-options">
                    {item.options.map((opt, i) => (
                        <li key={i}>{`${opt.optionTitle}: ${opt.valueTitle}`}</li>
                    ))}
                </ul>
            );
        }
        const imageUrl =
            Array.isArray(item.product.images) && item.product.images.length
                ? item.product.images[0]
                : '/images/products/no_img.jpg';
        const image = (
            <div className="dropcart__product-image">
                <Link to={`/shop/product/${item.product.id}`}>
                    <img src={imageUrl} alt={item.product.name} />
                </Link>
            </div>
        );

        if (item.options) {
            options = (
                <ul className="dropcart__product-options">
                    {item.options.map((option, index) => (
                        <li key={index}>{`${option.optionTitle}: ${option.valueTitle}`}</li>
                    ))}
                </ul>
            );
        }

        

        // if (item.miniature) {
        //     image = (
        //         <div className="dropcart__product-image">
        //             <Link to={`/shop/product/${item.product.uuid}`}><img src={`data:image/jpeg;base64,${item.miniature.data}`}  alt="" /></Link>
        //         </div>
        //     )
        // }else {
        //     image = (
        //         <div className="dropcart__product-image">
        //             <Link to={`/shop/product/${item.product.uuid}`}><img src={"/images/products/no_img.jpg"} alt="no_img" /></Link>
        //         </div>
        //     );
        // }

        const removeButton = (
            <AsyncAction
                action={() => cartRemoveItem(item.id)}
                render={({ run, loading }) => {
                    const classes = classNames('dropcart__product-remove btn btn-light btn-sm btn-svg-icon', {
                        'btn-loading': loading,
                    });

                    return (
                        <button type="button" onClick={run} className={classes}>
                            <Cross10Svg />
                        </button>
                    );
                }}
            />
        );

        return (
            <div key={item.id} className="dropcart__product">
                {image}
                <div className="dropcart__product-info">
                    <div className="dropcart__product-name">
                        <Link to={`/shop/product/${item.product.id}`}>{item.product.name}</Link>
                    </div>
                    {options}
                    <div className="dropcart__product-meta">
                        <span className="dropcart__product-quantity">{item.quantity}</span>
                        {' x '}
                        <span className="dropcart__product-price"><Currency value={item.price} currency={item.currency} /></span>
                    </div>
                </div>
                {removeButton}
            </div>
        );
    });

    if (cart.quantity) {
        dropdown = (
            <div className="dropcart">
                <div className="dropcart__products-list">
                    {items}
                </div>

                <div className="dropcart__totals">
                    <table>
                        <tbody>
                            {totals}
                            <tr>
                                <th>Итого</th>
                                <td><Currency value={cart.total} /></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="dropcart__buttons">
                    <Link className="btn btn-secondary" to="/shop/cart">Корзина</Link>
                    <Link className="btn btn-primary" to="/shop/checkout">К оплате</Link>
                </div>
            </div>
        );
    } else {
        dropdown = (
            <div className="dropcart">
                <div className="dropcart__empty">
                    Ваша корзина пуста!
                </div>
            </div>
        );
    }

    return (
        <Indicator url="/shop/cart" dropdown={dropdown} value={cart.quantity} icon={<Cart20Svg />} />
    );
}

const mapStateToProps = (state) => ({
    cart: state.cart,
});

const mapDispatchToProps = {
    cartRemoveItem,
};

export default connect(mapStateToProps, mapDispatchToProps)(IndicatorCart);
